import {
  Box,
  Button,
  Center,
  Divider,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  Text,
} from "@chakra-ui/react";
import { useState } from "react";
import { SignIn_DB } from "../../api";

const MobileNoForm = ({ toggleMobileAuthenticate }) => {
  const initialstate = { isEmpty: false, notProperLength: false, number: "" };
  const [validator, setValidator] = useState({ ...initialstate });
  const [user, setUser] = useState({ user: "" });
  const [loadingSignup, setLoadingSignup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const onNumberChange = (event) => {
    let inputMobileNumber = event.target.value;
    if (inputMobileNumber.length == 0) {
      setValidator({
        notProperLength: false,
        isEmpty: true,
        number: inputMobileNumber,
      });
    } else {
        setValidator({
          isEmpty: false,
          notProperLength: false,
          number: inputMobileNumber,
        });
    }
  };
  const onUserChanged = (event) => {
    setUser({user:event.target.value});
  };

  const handlesubmit = (event) => {
    event.preventDefault();
    if (!validator.isEmpty && !validator.notProperLength) {
      if (validator.number.length == 0) {
        setValidator({ ...validator, isEmpty: true });
        return;
      }

      const result = { userid: user.user, password: validator.number };
      setLoadingSignup(true);
      setErrorMessage("");
      fetch(SignIn_DB, {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(result),
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          return Promise.reject(response);
        })
        .then((data) => {
          if (data === "Done") {
            toggleMobileAuthenticate(user.user, false);
          } else if (data === "Seller") {
            toggleMobileAuthenticate(user.user, true);
          } else {
            setErrorMessage("Wrong credentials to login");
          }
        })
        .catch((response) => {
          setErrorMessage("Wrong Credentials, Please Try Again");
          console.log(response.status, response.statusText);
        })
        .finally(() => {
          setLoadingSignup(false);
        });
    }
  };
  return (
    <Box padding="30px 48px">
      <Box>
        <Text fontSize={"26px"} fontWeight="bold" mb={"8px"}>
          Sign In
        </Text>
        <Text color={"rgba(21,27,57,.6)"} fontSize="14px" mb="35px">
          Sign in to access your orders, special offers, health tips
          and more!
        </Text>
        {errorMessage && (
        <Text fontSize="14px" color="red" mt="10px">
          {errorMessage}
        </Text>
      )}
      </Box>
      
      <form onSubmit={handlesubmit}>
      

        <Text fontSize={"13px"} mt={"10px"} color="#5e17eb" paddingBlock={"3px"}>
          User ID
        </Text>
        <InputGroup variant="flushed" paddingBlock={"3px"}>
          <Input
            paddingBlock={"3px"}
            height="24px"
            type="text"
            placeholder="Enter Your Customer ID"
            fontSize={"16px"}
            onChange={onUserChanged}
          />
        </InputGroup>

        <Text fontSize={"13px"} color="#5e17eb" paddingBlock={"3px"}>
          Password
        </Text>
        <InputGroup variant="flushed" paddingBlock={"3px"}>
          <Input
            paddingBlock={"3px"}
            height="24px"
            type="password"
            placeholder="Enter your Password"
            fontSize={"16px"}
            onChange={onNumberChange}
          />
        </InputGroup>

        <Button
          type="submit"
          isLoading={loadingSignup}
          mt="24px"
          bg={'#5e17eb'}
          color="white"
          fontSize="14px"
          paddingBlock={"10px"}
          height="41px"
          width={"100%"}
          _hover={{ background: 'green'}}
        >
          Login
        </Button>
      </form>
    </Box>
  );
};
export default MobileNoForm;
